<template>
  <div class="content-main page-loading">
    <div class="loading">
      <van-loading type="spinner" />
      <span>加载中</span>
    </div>
  </div>
</template>

<script>
import { Loading } from 'vant'

export default{
  components: {
    [Loading.name]: Loading
  },
  data(){
    return {

    }
  },
  methods: {
    getUserinfoByCode(){
      var searchParams = new URLSearchParams(window.location.search)
      this.$api.get('/zhishicheap/get_userid_by_code', {code: searchParams.get("code")}, res => {
        if(res.code == 200 && res.userid){
          // alert('getUserinfoByCode: ' + JSON.stringify(res.userid))
          var searchParams = new URLSearchParams(window.location.search)
          var destination = searchParams.get("destination")

          this.$store.commit('setUserinfoBase', {
            userid: res.userid,
            user_type: res.user_type,
            destination: destination
          })
        }else{
          // alert('getUserinfoByCode: ' + 'wrent wrong!')
        }
      })
    },
    setHtmlFontSize () {
      const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
      const htmlDom = document.getElementsByTagName('html')[0]
      htmlDom.style.fontSize = htmlWidth / 10 + 'px'
    }
  },
  mounted(){
    this.setHtmlFontSize()
    // var searchParams = new URLSearchParams(window.location.search)
    // alert('destination: ' + searchParams.get("destination"))
    this.getUserinfoByCode()
  }
}
</script>

<style scoped>
.page-loading{
  font-size:28px;
  padding-top:30%;
  height:100vh;
}
/* .loading{
  font-size:12px;
  margin-top:30%;
} */
.van-loading{
  margin:0 auto;
  margin-bottom:15px;
}
</style>
